import { AgentType } from "./Agent.type";

const initialState = {
  agents: [],
  editAgentData: {},
  allAgents: [],
  emailsList: [],
  smsList: [],
};

function AgentReducer(state = initialState, action) {
  switch (action.type) {
    case AgentType.GET_AGENT_DATA: {
      return {
        ...state,
        agents: action.payload.data,
      };
    }
    case AgentType.EDIT_AGENT_DATA: {
      return {
        ...state,
        editAgentData: action.payload,
      };
    }
    case AgentType.GET_ALL_AGENT: {
      return {
        ...state,
        allAgents: action.payload.data,
      };
    }
    case AgentType.ALL_EMAILS_THREADS: {
      return {
        ...state,
        emailsList: action.payload,
      };
    }
    case AgentType.ALL_SMS_THREADS: {
      return {
        ...state,
        smsList: action.payload,
      };
    }

    default:
      return state;
  }
}

export default AgentReducer;
